<template>
  <div>
    <div v-if="getFilteredSubscribedProducts.length > 0" class="container-fluid px-0 product-cta-container">
      <div class="row">
        <div class="col-12">
          <GetAnswers background-color="blue">
            <template #content>
              <div class="col-9 pr-0">
                <div class="mt-2 mb-1 mb-sm-2">
                  <h3 class="cta-title" v-html-safe="$t('message.spotlight.cta.getAnswers')"></h3>
                </div>
              </div>
              <div class="col-3 text-right">
                <img
                  class="d-inline d-sm-none car-mobile"
                  :src="require(`@/assets/car_question-mobile.svg`)"
                  alt=""
                  width="73"
                  height="79"
                />
                <img class="d-none d-sm-inline pr-4" :src="require(`@/assets/car_question-desktop.svg`)" alt="" />
              </div>
            </template>
          </GetAnswers>
        </div>
      </div>
      <div class="row form-row">
        <div class="col-12 mb-5" :class="[hasTestDrive ? 'col-sm-7' : 'col-sm-12']">
          <CTA
            v-for="(product, index) in getFilteredSubscribedProducts"
            :key="index"
            :label="$t(`message.product.${product}.cta`)"
            :class="{ 'd-block d-sm-none': product === 'testDrive' }"
            @click="ctaClick(product)"
          ></CTA>
        </div>
        <div v-if="hasTestDrive" class="d-none d-sm-flex mb-5" :class="[hasTestDrive ? 'col-sm-5' : '']">
          <div class="cta-column">
            <h3>{{ $t('message.spotlight.cta.testDrive.title') }}</h3>
            <p>{{ $t('message.spotlight.cta.testDrive.text') }}</p>
            <MobialisButton class="mt-4 mb-1" type="button" size="btn-md" @click="ctaClick('testDrive')">{{
              $t('message.spotlight.cta.testDrive.buttonText')
            }}</MobialisButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GetAnswers from '@/components/GetAnswers.vue';
import CTA from '@/components/CTA.vue';
import log from '@/services/log';
import { AVRProducts } from '@/utils/enums';
import helperFunctions from '@/utils/helperFunctions';

export default {
  name: 'ProductCTAs',
  components: {
    GetAnswers,
    CTA,
  },
  computed: {
    ...mapGetters(['getProductHomeRoute']),
    ...mapGetters('business', ['getSubscribedProducts', 'isEcomV2Enabled']),
    ...mapGetters('lead', ['isLeadCreated']),
    ...mapGetters('vehicle', ['vehicleString']),
    showEcomCta() {
      return (
        this.isEcomV2Enabled && !this.isLeadCreated && this.vehicleString != null && this.$route.query.purchasePrice
      );
    },
    currentProduct() {
      return helperFunctions.getProductFromRoute(this.$route.path);
    },
    getFilteredSubscribedProducts() {
      const CTAProducts = [
        AVRProducts.CREDIT,
        AVRProducts.TRADE,
        AVRProducts.INSURANCE,
        AVRProducts.TEST_DRIVE,
        AVRProducts.REVIEWS,
        AVRProducts.SPIN,
      ];
      const filteredProducts = this.getSubscribedProducts.filter(
        value => ![this.currentProduct].includes(value) && CTAProducts.includes(value)
      );
      if (this.showEcomCta) {
        filteredProducts.push(AVRProducts.ECOMV2);
      }

      return filteredProducts;
    },
    hasTestDrive() {
      return this.getSubscribedProducts.includes(AVRProducts.TEST_DRIVE);
    },
  },
  methods: {
    ctaClick(product) {
      if (product === AVRProducts.SPOTLIGHT) {
        // GA Event tracking for spotlight only
        this.$ga.event('SiriusXM', 'click', `${product}_clicked--${this.$route.path}`);
      }

      // Internal analytics tracking
      const payload = {
        elementInteractedWith: `${this.currentProduct}.cta.${product}.click`,
      };
      this.$store.dispatch('metrics/logModalInteraction', payload).catch(error => {
        log('Error in logging interaction', error);
      });

      // Resetting the state, and using a key to redirect to Ecom to ensure there are no duplicate leads created
      // For context on why this is being coded this way please see Jira Ticket AVRES-341
      if (product === AVRProducts.ECOMV2) {
        this.$store.commit('PREPARE_TO_RESET_VUE_STATE', this.$store.state.initialStoreState);
        this.$store.replaceState(this.$store.state.initialStoreState);
        this.$store.commit('UPDATE_APP_COMPONENT_KEY');
      }
      this.$router.push({ path: this.getProductHomeRoute(product) });
    },
  },
};
</script>

<style scoped lang="scss">
.cta-column {
  border-radius: 6px;
  border: 1px solid rgb(218, 226, 234);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  padding: 40px 20px 31px;
  position: relative;
}
.car-mobile {
  position: relative;
  right: 0;
  top: 10px;
}
</style>
